/** Site header element used for sticky offset calculations. */
export function getSiteHeaderElement(): HTMLElement | null {
  return document.getElementById("botb-header") ?? document.querySelector<HTMLElement>(".mainHeader");
}

/** Publishes the live header height so sticky bars share the same offset. */
export function syncStickyHeaderHeight(): void {
  const header = getSiteHeaderElement();
  if (!header) return;

  const height = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty("--header-height", `${height}px`);
}

/** Header height for scroll offsets; measures the DOM, then falls back to `--header-height`. */
export function getStickyHeaderHeight(): number {
  syncStickyHeaderHeight();

  const header = getSiteHeaderElement();
  if (header) {
    return header.getBoundingClientRect().height;
  }

  const parsed = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
  return Number.isFinite(parsed) ? parsed : 0;
}
